export const apiHomePageHeader = (parms?: string) => {
  return fetch('/AjaxHomePageHeader.aspx' + (parms ?? ''), {
    method: "POST",
  }).then(res => {
    if (!res.ok) {
      const error = new Error(res.statusText);
      //@ts-ignore
      error.response = res;
      throw error;
    } else {
      return res.text();
    }
  })
}